import type {
  RecallCapacityEstimateApiData,
  RecallCapacityEstimateApiResponses,
  RecallConfigCreateApiData,
  RecallConfigCreateApiResponses,
  RecallConfigGetApiData,
  RecallConfigGetApiResponses,
  RecallConfigPatchApiData,
  RecallConfigPatchApiResponses,
  RecallCurrentSeasonApiData,
  RecallCurrentSeasonApiResponses,
  RecallFilterCountsCarWheelIdentifiersApiData,
  RecallFilterCountsCarWheelIdentifiersApiResponses,
  RecallFilterCountsCustomerGroupTypesApiData,
  RecallFilterCountsCustomerGroupTypesApiResponses,
  RecallFilterCountsCustomerSegmentsApiData,
  RecallFilterCountsCustomerSegmentsApiResponses,
  RecallFilterCountsLocationTypesApiData,
  RecallFilterCountsLocationTypesApiResponses,
  RecallFilterCountsSeasonsApiData,
  RecallFilterCountsSeasonsApiResponses,
  RecallFilterCountsServiceAreasApiData,
  RecallFilterCountsServiceAreasApiResponses,
  RecallFilterCountsStatusesApiData,
  RecallFilterCountsStatusesApiResponses,
  RecallFilterCountsStuddedApiData,
  RecallFilterCountsStuddedApiResponses,
  RecallFilterCountsTireHotelSeasonSegmentsApiData,
  RecallFilterCountsTireHotelSeasonSegmentsApiResponses,
  RecallFilterCountsTypesApiData,
  RecallFilterCountsTypesApiResponses,
  RecallFilterCountsWheelSetStorageSeasonsApiData,
  RecallFilterCountsWheelSetStorageSeasonsApiResponses,
  RecallFilterCountsWorkTabsApiData,
  RecallFilterCountsWorkTabsApiResponses,
  RecallProgramCreateApiData,
  RecallProgramCreateApiResponses,
  RecallProgramCreateSingleApiData,
  RecallProgramCreateSingleApiResponses,
  RecallProgramGetApiData,
  RecallProgramGetApiResponses,
  RecallProgramListApiData,
  RecallProgramListApiResponses,
  RecallProgramPatchApiData,
  RecallProgramPatchApiResponses,
  RecallProgramPatchDetailApiData,
  RecallProgramPatchDetailApiResponses,
  RecallProgramResponseStatsApiData,
  RecallProgramResponseStatsApiResponses,
  RecallProgramRunApiData,
  RecallProgramRunApiResponses,
  RecallProgramRunDetailApiData,
  RecallProgramRunDetailApiResponses,
  RecallProposalAnnotationsListApiData,
  RecallProposalAnnotationsListApiResponses,
  RecallProposalGetApiData,
  RecallProposalGetApiResponses,
  RecallProposalListApiData,
  RecallProposalListApiResponses,
  RecallProposalPublishJobStatusApiData,
  RecallProposalPublishJobStatusApiResponses,
  RecallProposalSelectionApiData,
  RecallProposalSelectionApiResponses,
  RecallRemindersSendJobRecord,
  RecallRunListApiData,
  RecallRunListApiResponses,
  RecallSeasonsApiData,
  RecallSeasonsApiResponses,
  WheelChangeSegmentationAffectedListApiData,
  WheelChangeSegmentationAffectedListApiResponses,
  WheelChangeSegmentationRunGetApiData,
  WheelChangeSegmentationRunGetApiResponses,
  WheelChangeSegmentationUnitListApiData,
  WheelChangeSegmentationUnitListApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getRecallUrls = {
  getWheelChangeSegmentationRun: dataEndpoint<
    WheelChangeSegmentationRunGetApiData,
    WheelChangeSegmentationRunGetApiResponses
  >({
    getUrl: ({ runId }) => apiUrl(`wheel-change-segmentation-runs/${runId}/`)
  }),
  getPaginatedWheelChangeSegmentationUnits: dataEndpoint<
    WheelChangeSegmentationUnitListApiData,
    WheelChangeSegmentationUnitListApiResponses
  >({
    getUrl: ({ runId, ...queryParams }) => apiUrl(`wheel-change-segmentation-runs/${runId}/units/`, queryParams)
  }),
  getPaginatedWheelChangeSegmentationAffected: dataEndpoint<
    WheelChangeSegmentationAffectedListApiData,
    WheelChangeSegmentationAffectedListApiResponses
  >({
    getUrl: ({ runId, ...queryParams }) => apiUrl(`wheel-change-segmentation-runs/${runId}/affected/`, queryParams)
  }),
  getPaginatedRecallProposals: dataEndpoint<RecallProposalListApiData, RecallProposalListApiResponses>({
    getUrl: ({ serviceDepartmentId, ...queryParams }) => apiUrl(`recalls/${serviceDepartmentId}/`, queryParams)
  }),
  getRecallProposalSelection: dataEndpoint<RecallProposalSelectionApiData, RecallProposalSelectionApiResponses>({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`recalls/${serviceDepartmentId}/selection/`, queryParams)
  }),
  getRecallDetail: dataEndpoint<RecallProposalGetApiData, RecallProposalGetApiResponses>({
    getUrl: ({ bookingProposalId }) => apiUrl(`recalls/${bookingProposalId}/detail/`)
  }),
  getRecallPublishJobStatus: dataEndpoint<
    RecallProposalPublishJobStatusApiData,
    RecallProposalPublishJobStatusApiResponses
  >({
    getUrl: ({ jobId }) => apiUrl(`recalls/publish-job/${jobId}/`)
  }),
  getRecallSeasons: dataEndpoint<RecallSeasonsApiData, RecallSeasonsApiResponses>({
    getUrl: () => apiUrl('recalls/seasons/')
  }),
  getRecallSeasonCurrent: dataEndpoint<RecallCurrentSeasonApiData, RecallCurrentSeasonApiResponses>({
    getUrl: () => apiUrl('recalls/season-current/')
  }),
  getRecallFilterCountsCustomerGroupTypes: dataEndpoint<
    RecallFilterCountsCustomerGroupTypesApiData,
    RecallFilterCountsCustomerGroupTypesApiResponses
  >({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`recalls/${serviceDepartmentId}/filter-counts/customer-group-types/`, queryParams)
  }),
  getRecallFilterCountsLocationTypes: dataEndpoint<
    RecallFilterCountsLocationTypesApiData,
    RecallFilterCountsLocationTypesApiResponses
  >({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`recalls/${serviceDepartmentId}/filter-counts/location-types/`, queryParams)
  }),
  getRecallFilterCountsSeasons: dataEndpoint<RecallFilterCountsSeasonsApiData, RecallFilterCountsSeasonsApiResponses>({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`recalls/${serviceDepartmentId}/filter-counts/seasons/`, queryParams)
  }),
  getRecallFilterCountsTireHotelSeasonSegments: dataEndpoint<
    RecallFilterCountsTireHotelSeasonSegmentsApiData,
    RecallFilterCountsTireHotelSeasonSegmentsApiResponses
  >({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`recalls/${serviceDepartmentId}/filter-counts/tire-hotel-season-segments/`, queryParams)
  }),
  getRecallFilterCountsStatuses: dataEndpoint<
    RecallFilterCountsStatusesApiData,
    RecallFilterCountsStatusesApiResponses
  >({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`recalls/${serviceDepartmentId}/filter-counts/statuses/`, queryParams)
  }),
  getRecallFilterCountsWorkTabs: dataEndpoint<
    RecallFilterCountsWorkTabsApiData,
    RecallFilterCountsWorkTabsApiResponses
  >({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`recalls/${serviceDepartmentId}/filter-counts/work-tabs/`, queryParams)
  }),
  getRecallFilterCountsTypes: dataEndpoint<RecallFilterCountsTypesApiData, RecallFilterCountsTypesApiResponses>({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`recalls/${serviceDepartmentId}/filter-counts/types/`, queryParams)
  }),
  getRecallFilterCountsStudded: dataEndpoint<RecallFilterCountsStuddedApiData, RecallFilterCountsStuddedApiResponses>({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`recalls/${serviceDepartmentId}/filter-counts/studded/`, queryParams)
  }),
  getRecallFilterCountsCarWheelIdentifiers: dataEndpoint<
    RecallFilterCountsCarWheelIdentifiersApiData,
    RecallFilterCountsCarWheelIdentifiersApiResponses
  >({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`recalls/${serviceDepartmentId}/filter-counts/car-wheel-identifiers/`, queryParams)
  }),
  getRecallFilterCountsWheelSetStorageSeasons: dataEndpoint<
    RecallFilterCountsWheelSetStorageSeasonsApiData,
    RecallFilterCountsWheelSetStorageSeasonsApiResponses
  >({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`recalls/${serviceDepartmentId}/filter-counts/wheel-set-storage-seasons/`, queryParams)
  }),
  getRecallFilterCountsServiceAreas: dataEndpoint<
    RecallFilterCountsServiceAreasApiData,
    RecallFilterCountsServiceAreasApiResponses
  >({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`recalls/${serviceDepartmentId}/filter-counts/service-areas/`, queryParams)
  }),
  getRecallFilterCountsCustomerSegments: dataEndpoint<
    RecallFilterCountsCustomerSegmentsApiData,
    RecallFilterCountsCustomerSegmentsApiResponses
  >({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`recalls/${serviceDepartmentId}/filter-counts/customer-segments/`, queryParams)
  }),
  getRecallConfig: dataEndpoint<RecallConfigGetApiData, RecallConfigGetApiResponses>({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/recall-config/`)
  }),
  postRecallConfig: responseEndpoint<RecallConfigCreateApiData, RecallConfigCreateApiResponses>({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/recall-config/`),
    getBody: ({ serviceDepartmentId: _, ...body }) => body
  }),
  patchRecallConfig: responseEndpoint<RecallConfigPatchApiData, RecallConfigPatchApiResponses>({
    getUrl: ({ serviceDepartmentId, recallConfigId }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/recall-config/${recallConfigId}/`),
    getBody: ({ serviceDepartmentId: _, recallConfigId: _id, ...body }) => body
  }),
  getRecallCapacityEstimate: dataEndpoint<RecallCapacityEstimateApiData, RecallCapacityEstimateApiResponses>({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`recalls/${serviceDepartmentId}/capacity-estimate/`, queryParams)
  }),
  getRecallProposalAnnotations: dataEndpoint<
    RecallProposalAnnotationsListApiData,
    RecallProposalAnnotationsListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('recalls/annotations/', queryParams)
  }),
  getRecallProgram: dataEndpoint<RecallProgramGetApiData, RecallProgramGetApiResponses>({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/recall-program/`)
  }),
  getRecallPrograms: dataEndpoint<RecallProgramListApiData, RecallProgramListApiResponses>({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/recall-programs/`, queryParams)
  }),
  getRecallProgramResponseStats: dataEndpoint<
    RecallProgramResponseStatsApiData,
    RecallProgramResponseStatsApiResponses
  >({
    getUrl: ({ serviceDepartmentId }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/recall-programs/response-stats/`)
  }),
  postRecallCampaign: responseEndpoint<RecallProgramCreateApiData, RecallProgramCreateApiResponses>({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/recall-programs/`),
    getBody: ({ serviceDepartmentId: _, ...body }) => body
  }),
  postRecallProgram: responseEndpoint<RecallProgramCreateSingleApiData, RecallProgramCreateSingleApiResponses>({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/recall-program/`),
    getBody: ({ serviceDepartmentId: _, ...body }) => body
  }),
  patchRecallProgram: responseEndpoint<RecallProgramPatchApiData, RecallProgramPatchApiResponses>({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/recall-program/`),
    getBody: ({ serviceDepartmentId: _, ...body }) => body
  }),
  patchRecallCampaign: responseEndpoint<RecallProgramPatchDetailApiData, RecallProgramPatchDetailApiResponses>({
    getUrl: ({ serviceDepartmentId, recallProgramId }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/recall-programs/${recallProgramId}/`),
    getBody: ({ serviceDepartmentId: _, recallProgramId: _id, ...body }) => body
  }),
  getRecallProgramRuns: dataEndpoint<RecallRunListApiData, RecallRunListApiResponses>({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/recall-program/runs/`, queryParams)
  }),
  postRecallProgramRun: responseEndpoint<RecallProgramRunDetailApiData, RecallProgramRunDetailApiResponses>({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/recall-program/run/`),
    getBody: ({ serviceDepartmentId: _, ...body }) => body
  }),
  postRecallCampaignRun: responseEndpoint<RecallProgramRunApiData, RecallProgramRunApiResponses>({
    getUrl: ({ serviceDepartmentId, recallProgramId }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/recall-programs/${recallProgramId}/run/`),
    getBody: ({ serviceDepartmentId: _, recallProgramId: _id, ...body }) => body
  })
};

export { getRecallProgramTemplateUrls } from './recallProgramTemplates';
export { getRecallReminderUrls } from './reminderUrls';
export type { RecallRemindersSendJobRecord };
